import { Config } from '../Config';
import * as httpClient from './HttpClient';

export const sendMail = async data => {
  const url = `${Config.API_URL}mail/send-mail`;
  return await httpClient.post(url, data);
};
